export const DEFAULT_PERMISSION = {
    admin: false,
    write: true,
    read: true,
};
